import { Mail, MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { CONTACT } from "@/data/content";
import { MaskLine, Reveal } from "@/components/site/Reveal";

export default function ContactPage() {
  const { t } = useLanguage();
  const rows = [
    {
      icon: Mail,
      label: t.contact.emailLabel,
      value: CONTACT.email,
      href: `mailto:${CONTACT.email}`,
      id: "email",
    },
    {
      icon: MapPin,
      label: t.contact.locationLabel,
      value: t.contact.locationValue,
      href: null,
      id: "location",
    },
  ];

  return (
    <div data-testid="contact-page" className="pt-32 md:pt-48">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.24em] text-lagoon">
            <span className="h-px w-10 bg-lagoon" />
            {t.contact.overline}
          </p>
        </Reveal>
        <h1 className="mt-4 font-serif text-[clamp(3.5rem,12vw,10rem)] leading-[0.95] tracking-tight text-ink">
          <MaskLine delay={0.1}>{t.contact.title}</MaskLine>
        </h1>
        <Reveal delay={0.2}>
          <p className="mt-8 max-w-lg text-base leading-relaxed text-ink/60 md:text-lg">
            {t.contact.intro}
          </p>
        </Reveal>

        <div className="mt-16 border-t border-ink/10 md:mt-24">
          {rows.map((row, i) => {
            const Icon = row.icon;
            const inner = (
              <>
                <span className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink/40 md:w-56">
                  <Icon className="h-4 w-4 text-lagoon" strokeWidth={1.5} />
                  {row.label}
                </span>
                <span
                  data-testid={`contact-${row.id}`}
                  className="font-serif text-2xl tracking-tight text-ink transition-colors duration-300 group-hover:text-lagoon sm:text-3xl md:text-5xl"
                >
                  {row.value}
                </span>
              </>
            );
            const cls =
              "group flex flex-col gap-4 border-b border-ink/10 py-10 md:flex-row md:items-center md:gap-10 md:py-14";
            return (
              <Reveal key={row.id} delay={0.08 * i}>
                {row.href ? (
                  <a data-testid={`contact-link-${row.id}`} href={row.href} className={cls}>
                    {inner}
                  </a>
                ) : (
                  <div className={cls}>{inner}</div>
                )}
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-sm italic text-ink/40">{t.contact.note}</p>
        </Reveal>
      </div>
      <div className="h-24 md:h-40" />
    </div>
  );
}
